'use strict';

function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

module.exports = endsWith;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/utils/endsWith.js
 ** module id = 158
 ** module chunks = 0
 **/